import { render, staticRenderFns } from "./4_AidesFMA21.vue?vue&type=template&id=22545150&scoped=true&"
import script from "./4_AidesFMA21.vue?vue&type=script&lang=js&"
export * from "./4_AidesFMA21.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22545150",
  null
  
)

export default component.exports